/**
 * Calcula el porcentaje de victoria
 */
export const calculateWinRate = (gamesWon, gamesPlayed) => {
  if (gamesPlayed === 0) return 0;
  return Math.round((gamesWon / gamesPlayed) * 100);
};

/**
 * Calcula el promedio de dardos por partida
 */
export const calculateAverageDarts = (totalDarts, gamesPlayed) => {
  if (gamesPlayed === 0) return 0;
  return Math.round((totalDarts / gamesPlayed) * 10) / 10;
};

/**
 * Calcula el promedio de puntos por dardo
 */
export const calculateAverageScorePerDart = (totalScore, totalDarts) => {
  if (totalDarts === 0) return 0;
  return Math.round((totalScore / totalDarts) * 10) / 10;
};

/**
 * Valida si una puntuación es válida en el juego 501
 */
export const isValidScore = (score) => {
  return score >= 0 && score <= 180; // Máximo teórico con 3 dardos en triple 20
};

/**
 * Valida si el movimiento es legal en el juego 501
 * - No se puede hacer más de 180 puntos
 * - No se puede quedar con exactamente 1 punto
 */
export const isValidMove = (currentScore, scoreToSubtract) => {
  if (!isValidScore(scoreToSubtract)) return false;
  
  const newScore = currentScore - scoreToSubtract;
  
  // No se puede tener puntuación negativa
  if (newScore < 0) return false;
  
  // No se puede quedar con exactamente 1 punto
  if (newScore === 1) return false;
  
  return true;
};

/**
 * Comprueba si el jugador ha ganado la partida
 */
export const hasWonGame = (score) => {
  return score === 0;
};

/**
 * Resetea las puntuaciones para una nueva partida
 */
export const resetGameScores = () => {
  return [501, 501];
};

/**
 * Formatea el tiempo de duración de una partida
 */
export const formatGameDuration = (startTime, endTime) => {
  const duration = endTime.getTime() - startTime.getTime();
  const minutes = Math.floor(duration / 60000);
  const seconds = Math.floor((duration % 60000) / 1000);
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};
